import React, { Component } from 'react';
import Channels from './channels'

import AdminLayout from "../../components/adminLayout";

export default class Engage extends Component {
    constructor(props) {
        super(props);
        
        this.Channels = Channels.bind(this)
    }
    
    render() {
        return (

            <AdminLayout>
                    <Channels/>
                </AdminLayout>
        )
    }
}